import { ViewBooking } from "collins-js-sdk";

// Case-insensitive comparison of a booking's currentStage against a stage name.
// Shared by booking.ts and bookingFilters.ts so the two stay in sync.
export const stageIs = (booking: ViewBooking, stage: string): boolean =>
  typeof booking.currentStage === "string" &&
  booking.currentStage.toLowerCase() === stage;
